import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BUILDING_TYPES } from '../../data/building-types';
import { WINDOW_TYPES } from '../../data/window-types';
import { FRAME_TYPES } from '../../data/frame-types';
import { SYSTEM } from '../../data/system';
import _ from 'lodash';
import { StorageService } from 'src/app/services/storage.service';
import { Subscription } from 'rxjs';
import { Storage } from 'src/app/models/storage';
import { FIND_SYSTEM_RULES } from '../../data/storage';

@Component({
  selector: 'app-system-type-finder',
  templateUrl: './system-type-finder.component.html',
})
export class SystemTypeFinderComponent implements OnInit {
  form: FormGroup;
  subscription: Subscription;
  storage: Storage;
  filterResult = [null, null];

  readonly BUILDING_TYPES = BUILDING_TYPES;
  readonly WINDOW_TYPES = WINDOW_TYPES;
  readonly FRAME_TYPES = FRAME_TYPES;
  readonly FIND_SYSTEM_RULES = FIND_SYSTEM_RULES;
  readonly SYSTEM = SYSTEM;

  constructor(
    private fb: FormBuilder,
    private storageService: StorageService,
  ) { }

  ngOnInit() {
    this.storage = this.storageService.storage;

    this.form = this.fb.group({
      buildingType: [
        this.storage.buildingType, [
          Validators.required
        ]
      ],
      windowType: [
        this.storage.windowType, [
          Validators.required
        ]
      ],
      frameType: [
        this.storage.frameType, [
          Validators.required
        ]
      ],
      systemType: [
        this.storage.systemType,
        [
          Validators.required
        ]
      ],
    });

    this.storageSubscription();
    this.onFormChange();
  }

  private storageSubscription() {
    this.subscription = this.storageService.storage$.subscribe(async (data) => {
      this.storage = data;
      this.onFormPatchValues();
    });
  }

  private onFormPatchValues() {
    const formValues = {};
    _.forEach(this.form.getRawValue(), (value, prop) => {
      formValues[prop] = this.storage[prop];
    });

    this.form.patchValue(
      formValues, {
      emitEvent: false,
    });
  }

  private onFormChange() {
    this.form.valueChanges.subscribe((field) => {
      _.merge(this.storage, field);
    });
  }

  findSystemTypes() {
    const path = [this.storage.buildingType, this.storage.windowType, this.storage.frameType];
    let sysFound = [null, null];
    for (const rule of FIND_SYSTEM_RULES) {
      if (JSON.stringify(rule.path) === JSON.stringify(path)) {
        sysFound = rule.system;
        break;
      }
    }
    this.filterResult = [this.storageService.getSystemIndexById(sysFound[0]), this.storageService.getSystemIndexById(sysFound[1])];
  }
}
